import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  sl-dialog::part(panel) {
    width: 700px;
    max-width: 90vw;
  }

  .action-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.5rem;
  }

  .action-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: var(--sl-color-neutral-700);
    margin: 0;
  }

  .action-meta {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
  }

  .action-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .detail-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .detail-label {
    font-weight: 500;
    color: var(--sl-color-neutral-600);
    font-size: 0.875rem;
  }

  .detail-value {
    color: var(--sl-color-neutral-900);
    font-size: 0.875rem;
  }

  .description-section {
    margin-bottom: 1.5rem;
  }

  .description-label {
    font-weight: 500;
    color: var(--sl-color-neutral-600);
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
  }

  .description-content {
    background: var(--sl-color-neutral-50);
    padding: 1rem;
    border-radius: 6px;
    color: var(--sl-color-neutral-900);
    line-height: 1.5;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }
`;
